// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"F3f","hidden":"F3b-","closeBtnWrap":"F3zt","closeBtn":"F3cx"};